import { SET_RECEIPTS } from '../actions/ConversationsAction';
const initConversationsState = {
    receipts: []
};
export const ConversationsReducer = (state = initConversationsState, action) => {
    if (action.type === SET_RECEIPTS)
        return Object.assign(Object.assign({}, state), { receipts: [...action.receipts] });
    else
        return state;
}